module.exports = __webpack_public_path__ + "static/media/criar-denuncia.9af92200.png";